module.exports = __webpack_public_path__ + "img/coupon-svg.ea920b36.svg";